import React from 'react';
import PropTypes from 'prop-types';

/**
 * Only renders its child component when the feature that is needed is enabled or active.
 * An alternative rendering can be provided in the `renderNotActive` prop function, otherwise
 * null is returned.
 *
 * It requires following props:
 *
 * * `feature` : string for the feature that is needed
 * * `isFeatureActive` : function is called with the feature string and returns if it is active or not.
 *                        Can also be a boolean, in this case the 'feature' prop isn't used
 *
 * This component is designed to work together with the FeatureFlagProvider,
 * a component that provides an implementation of the `isFeatureActive` function.
 */

const FeatureFlagWrapper = ({
  isFeatureActive,
  feature,
  renderActive = false,
  renderNotActive = () => null,
  children
}) => {
  if (isFeatureActive(feature)) {
    return (
      <>
        {renderActive && renderActive()}
        {!renderActive && children}
      </>
    );
  }
  return renderNotActive();
};

FeatureFlagWrapper.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.node,
  isFeatureActive: PropTypes.func.isRequired,
  renderActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  renderNotActive: PropTypes.func
};

export default FeatureFlagWrapper;
